export const MAX_BUTTON_INDEX = 3;

export const DATA_TESTID = "whatsapp-preview";

export const SEE_ALL_OPTIONS = 'See all options';

export const TEMPLATE_COPY_CODE_TEXT = "Copy offer code";

const TEMPLATE_IMAGE_BASEURL = 'https://gs-upload.gupshup.io/templates/';

export const PREVIEW_ICONS = `${TEMPLATE_IMAGE_BASEURL}icons/ic_`;

export const PREVIEW_REGEX = {
  NUMBER_REGEX           : "\\d+",
  ASTERISK_REGEX         : /\*/g,
  FIRST_VARIABLES        : "{{1}}",
  BRACKET_REGEX          : /[\[\]]/g,
  LTO_CODE_REGEX         : /^{{.*}}$/,
  DYNAMIC_VARIABLE_REGEX : /\{\{(\d+)\}\}/g,
};

export const DEFAULT_CONATINER_META = {
  data : "",
};

export const DEFAULT_PREVIEW_DETAILS = {
  showHeading : true,
  templateObj : {
    data          : "",
    category      : "",
    templateType  : "",
    containerMeta : DEFAULT_CONATINER_META,
  }
};

export const TEMPLATE_TYPE = {
  TEXT          : "TEXT",
  PRODUCT       : "PRODUCT",
  CATALOG       : "CATALOG",
  CAROUSEL      : "CAROUSEL",
  LOCATION      : "LOCATION",
  ORDER_STATUS  : "ORDER_STATUS",
  ORDER_DETAILS : "ORDER_DETAILS",
  MEDIA         : ["IMAGE","VIDEO", "DOCUMENT", "GIF"],
};

export const CATEGORY_TYPES = {
  AUTHENTICATION : "AUTHENTICATION",
};

export const DEFAULT_MEDIA_IMAGES = {
  GIF      : { name : 'GIF',      title : 'gif',      image_src : `${PREVIEW_ICONS}preview_video.svg`    },
  IMAGE    : { name : 'IMAGE',    title : 'image',    image_src : `${PREVIEW_ICONS}preview_image.svg`    },
  VIDEO    : { name : 'VIDEO',    title : 'video',    image_src : `${PREVIEW_ICONS}preview_video.svg`    },
  LOCATION : { name : 'LOCATION', title : 'location', image_src : `${PREVIEW_ICONS}preview_location.svg` },
  DOCUMENT : { name : 'DOCUMENT', title : 'document', image_src : `${PREVIEW_ICONS}preview_document.svg` },
};

export const BUTTON_LIST_TYPES = {
  OTP           : 'OTP',
  URL           : 'URL',
  CPR           : 'CPR',
  ONE_TAP       : 'ONE_TAP',
  PASSKEY       : 'PASSKEY',
  ZERO_TAP      : 'ZERO_TAP',
  COPY_CODE     : 'COPY_CODE',
  VOICE_CALL    : 'VOICE_CALL',
  ALLOPTIONS    : 'ALLOPTIONS',
  PHONE_NUMBER  : 'PHONE_NUMBER',
  PAY_NOW       : 'PAY_NOW',
  ORDER_DETAILS : 'ORDER_DETAILS',
};

export const DEFAULT_BUTTON_IMAGES = {
  OTP          : { base_icon : `${PREVIEW_ICONS}stats_copy_code.svg`,   icon : `${PREVIEW_ICONS}stats_copy_code.svg` },
  ALLOPTIONS   : { base_icon : `${PREVIEW_ICONS}stats_all_options.svg`, icon : "" },
  COPY_CODE    : { base_icon : `${PREVIEW_ICONS}stats_copy_code.svg`,   icon : `${PREVIEW_ICONS}stats_copy_code.svg` },
  URL          : { base_icon : `${PREVIEW_ICONS}stats_url.svg`,         icon : `${PREVIEW_ICONS}stats_url.svg` },
  PAY_NOW      : { base_icon : `${PREVIEW_ICONS}stats_url.svg`,         icon : `${PREVIEW_ICONS}stats_url.svg` },
  QUICK_REPLY  : { base_icon : `${PREVIEW_ICONS}stats_quick_reply.svg`, icon : `${PREVIEW_ICONS}stats_quick_reply.svg` },
  PHONE_NUMBER : { base_icon : `${PREVIEW_ICONS}stats_phone.svg`,       icon : `${PREVIEW_ICONS}stats_phone.svg` },
  VOICE_CALL   : { base_icon : `${PREVIEW_ICONS}stats_call.svg`,        icon : `${PREVIEW_ICONS}stats_call.svg` },
  ORDER_DETAILS: { base_icon : `${PREVIEW_ICONS}stats_url.svg`,         icon : `${PREVIEW_ICONS}stats_url.svg` },
};

export const LIMITED_TIME_OFFER = {
  DAYS             : "{{days}}",
  EXPIRY_DAYS      : "2",
  EXPIRY_SUBHEADER : "Ends in {{days}} day",
  EXPIRY_ICONPATH  : `${PREVIEW_ICONS}gift.svg`,
};

export const PRODUCT_MESSAGE = {
  MESSAGE           : "{{#}} items",
  ICONPATH          : `${TEMPLATE_IMAGE_BASEURL}images/marketing_header.webp`,
  CATALOG_HEADER    : "View {BIZ_NAME}’s Catalog on WhatsApp",
  CATALOG_SUBHEADER : "Browse pictures and details of their offerings.",
};

export const ORDER_STATUS = {
  MESSAGE   : "Jasper's Market",
  ORDERID   : "Order #123456789",
  SUBHEADER : "Bushel of carrots",
  ICONPATH  : `${TEMPLATE_IMAGE_BASEURL}images/sample_order_item.png`,
};

export const ORDER_DETAILS = {
  TOTAL     : "Total",
  AMOUNT    : "₹12.34",
  SUBHEADER : "Quanlity 1",
  ORDERID   : "Order #123456789",
  HEADER    : "Bushel of carrots",
  ICONPATH  : `${TEMPLATE_IMAGE_BASEURL}images/sample_order_item.png`,
};

export const CALL_PERMISSION = {
  MESSAGE : "Can {BIZ_NAME} call you?",
};

export const TEMPLATE_PREVIEW_DATA_TESTID = {
  BODY                    : `${DATA_TESTID}-body`,
  HEADER                  : `${DATA_TESTID}-header`,
  FOOTER                  : `${DATA_TESTID}-footer`,
  BUTTON                  : `${DATA_TESTID}-template-button`,
  BODY_PANEL              : `${DATA_TESTID}-body-panel`,
  TIMESTAMP               : `${DATA_TESTID}-time-stamp`,
  ALL_OPTIONS             : `${DATA_TESTID}-all-options`,
  MAIN_HEADING            : `${DATA_TESTID}-main-heading`,
  CAROUSEL_CARD           : `${DATA_TESTID}-carousel-card`,
  PASSKEY_HEADER          : `${DATA_TESTID}-passkey-header`,
  LTO_EXPIRY_CODE         : `${DATA_TESTID}-lto-expiry-code`,
  LTO_EXPIRY_ICON         : `${DATA_TESTID}-lto-expiry-icon`,
  MESSAGE_PREVIEW         : `${DATA_TESTID}-message-preview`,
  MARKETING_HEADER        : `${DATA_TESTID}-marketing-header`,
  LTO_EXPIRY_HEADER       : `${DATA_TESTID}-lto-expiry-header`,
  ORDER_STATUS_PANEL      : `${DATA_TESTID}-order-status-panel`,
  ORDER_STATUS_ICON       : `${DATA_TESTID}-order-status-image`,
  PASSKEY_DESCRIPTION     : `${DATA_TESTID}-passkey-description`,
  CAROUSEL_CARD_PANEL     : `${DATA_TESTID}-carousel-card-panel`,
  ORDER_DETAILS_TOTAL     : `${DATA_TESTID}-order-details-total`,
  ORDER_DETAILS_PANEL     : `${DATA_TESTID}-order-details-panel`,
  PREVIEW_BUTTON_LIST     : `${DATA_TESTID}-preview-button-list`,
  ORDER_STATUS_HEADER     : `${DATA_TESTID}-order-status-header`,
  MARKETING_SUB_HEADER    : `${DATA_TESTID}-marketing-sub-header`,
  ORDER_DETAILS_AMOUNT    : `${DATA_TESTID}-order-details-amount`,
  LTO_EXPIRY_SUBHEADER    : `${DATA_TESTID}-lto-expiry-subheader`,
  ORDER_STATUS_MESSAGE    : `${DATA_TESTID}-order-status-message`,
  ORDER_DETAILS_HEADER    : `${DATA_TESTID}-order-details-header`,
  ORDER_DETAILS_ORDERID   : `${DATA_TESTID}-order-details-orderid`,
  MESSAGE_PREVIEW_BUTTON  : `${DATA_TESTID}-message-preview-button`,
  CALL_PERMISSION_HEADER  : `${DATA_TESTID}-call-permission-header`,
  ORDER_STATUS_SUBHEADER  : `${DATA_TESTID}-order-status-subheader`,
  ORDER_DETAILS_SUBHEADER : `${DATA_TESTID}-order-details-subheader`,
};

export const CALL_PERMISSION_BUTTON = [
  {
    type : BUTTON_LIST_TYPES.CPR,
    text : "choose_preference",
  }
];

// --- Vendored from gs-ui-templates/src/constants/icons.ts ---
// Only the 4 TEMPLATE_ICONS keys this panel actually uses (WhatsAppPreview.js's WARNING_CIRCLE,
// PayNowPanel.js's UPI/VISA/MASTERCARD). Trailing spaces after ".png"/".svg" on the
// image ones are copied verbatim from the source object literal, not a typo introduced
// here.
const VENDORED_TEMPLATE_ICONS_PREFIX = "https://gs-upload.gupshup.io/templates/icons/ic_";
const VENDORED_TEMPLATE_IMAGE_PREFIX = "https://gs-upload.gupshup.io/templates/images/";

export const TEMPLATE_ICONS = {
  WARNING_CIRCLE : `${VENDORED_TEMPLATE_ICONS_PREFIX}warning.svg`,
  VISA           : `${VENDORED_TEMPLATE_IMAGE_PREFIX}visa.png `,
  MASTERCARD     : `${VENDORED_TEMPLATE_IMAGE_PREFIX}mastercard.png `,
  UPI            : `${VENDORED_TEMPLATE_IMAGE_PREFIX}upi.png `,
};

// --- Vendored from gs-ui-templates/src/constants/dataTestId.ts ---
// Only the 2 createTemplateTestId keys this panel uses. Values are the final strings
// the source computes from `${namespace.createTemplate}-${element.text}-...` (or, for
// interactiveMessage, a bare literal) — reproduced here without porting the 650-line
// namespace/element registry that produces them.
export const createTemplateTestId = {
  previewToolCurrently : "createTemplate-text-please-note-that-out-preview-tool-currently",
  interactiveMessage   : "icon-interactive-message",
};

// --- Vendored from gs-ui-templates/src/containers/Whatsapp/CreateTemplate/config.ts ---
export const AUTOFILL_LABEL = "Autofill";
export const COPY_CODE_LABEL = "Copy code";
export const PIX_CODE_TEXT = "Copy Pix code";

// --- Vendored from gs-ui-templates/src/constants/common.ts ---
// Used only by index.js. TEMPLATE_COPY_CODE_TEXT above already covers the
// identically-named/valued constant from that file; these two do not exist above yet.
export const TEMPLATE_COPY_CODE = "COPY_CODE";
export const LTO_OFFERCODE_EXPIRE_IN = "2";

// --- i18n-library replacement ---
// gs-ui-templates resolves button text through t(btn.text); that i18n library is not
// a target-repo dependency, so this reproduces its "fall back to the key itself when
// there's no translation" behaviour for the one real i18n key that flows through that
// path (CALL_PERMISSION_BUTTON above). Resolved from gs-ui-templates'
// src/i18n/locales/en.json.
export const BUTTON_TEXT_TRANSLATIONS = {
  choose_preference : "Choose preference",
};
